<template>
     <v-container grid-list-xs>
            <v-layout row wrap align-center justify-center>
      <v-flex text-xs-center xs12>
        <img id="intro" :src="GMLogo"/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import GordijnenManLogo from '../assets/logo-large.png';

  export default {
    name: "GordijnenManLogo",
    data: () => ({
      GMLogo: GordijnenManLogo
    })
  }
</script>

<style scoped>
#intro {
  width: 50%;
  position: relative;
  top:5em;
  left: 0;
  cursor: pointer;
}

@media screen and (max-width: 1024px) {
  #intro {
    top: 5em;
    width: 70%;
  }
}

@media screen and (max-width: 768px) {
  #intro {
    top: 8em;
    width: 80%;
  }
}

@media screen and (max-width: 425px){
    #intro {
    width: 100%;
    top:10em;
  }
}

</style>
